export const ApiProfessions = {
    get: params => ({
        url: '/professions',
        method: 'GET',
        params
    }),
    create: data => ({
        url: '/professions',
        method: 'POST',
        data
    }),
    update: (id, data) => ({
        url: `/professions/${id}`,
        method: 'PUT',
        data
    }),
    delete: (id) => ({
        url: `/professions/${id}`,
        method: 'DELETE',
    })
};